import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	featuresConfig: {
		padding: '1rem',
		margin: '2rem'
	},
	paperStyles: {
		paddding: '2rem !important'
	},
	checkboxInput: {
		width: '70%',
		margin: '0 auto',
		paddingBottom: '1rem'
	},
	checkboxInputTypography: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: '70%',

		padding: '0',
		textAlign: 'left'
	},	
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: '70%',
		padding: '0',
		textAlign: 'left',
		margin: '0 auto !important'
	},
	dividerStyles: {
		marginBottom: '1rem'
	},
	icon: {
		float: 'left',
		cursor: 'pointer',

		width: '70% !important',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.05)'
		},
		'&:active': {
			transform: 'scale(.8)'
		}
	}
}));
